const whiteLogosBR = {
    alfa: require('static/img/insurace-logos/alfa-white.png'),
    aliro: require('static/img/insurace-logos/aliro-white.png'),
    alirobr: require('static/img/insurace-logos/aliro-white.png'),
    allianzbr: require('static/img/insurace-logos/allianz-white.png'),
    azulbr: require('static/img/insurace-logos/azul-white.png'),
    azulbr2: require('static/img/insurace-logos/azul-white.png'),
    bradesco2: require('static/img/insurace-logos/bradesco-white.png'),
    bradescobr: require('static/img/insurace-logos/bradesco-white.png'),
    brandescoseguros: require('static/img/insurace-logos/bradesco-white.png'),
    cardifbr: require('static/img/insurace-logos/cardif-white.png'),
    hdiseguros: require('static/img/insurace-logos/hdi-white.png'),
    hdibr: require('static/img/insurace-logos/hdi-white.png'),
    hunterbr: require('static/img/insurace-logos/hunter-white.png'),
    itaubr: require('static/img/insurace-logos/itau-white.png'),
    ituranbr: require('static/img/insurace-logos/ituran-white.png'),
    justos_br: require('static/img/insurace-logos/justos-white.png'),
    justosbr: require('static/img/insurace-logos/justos-white.png'),
    libertyseguros: require('static/img/insurace-logos/liberty-white.png'),
    libertybr: require('static/img/insurace-logos/liberty-white.png'),
    mapfreseguros: require('static/img/insurace-logos/mapfre-white.png'),
    mapfrebr: require('static/img/insurace-logos/mapfre-white.png'),
    mapfrebr2: require('static/img/insurace-logos/mapfre-white.png'),
    mitsui_br: require('static/img/insurace-logos/mitsui-white.png'),
    portobr: require('static/img/insurace-logos/porto-white.png'),
    portobr2: require('static/img/insurace-logos/porto-white.png'),
    sancor_br: require('static/img/insurace-logos/sancor-white.png'),
    siggobr: require('static/img/insurace-logos/siggo-white.png'),
    sompo: require('static/img/insurace-logos/sompo-white.png'),
    sompobr: require('static/img/insurace-logos/sompo-white.png'),
    suhai: require('static/img/insurace-logos/suhai-white.png'),
    suhaibr: require('static/img/insurace-logos/suhai-white.png'),
    sulamerica: require('static/img/insurace-logos/sulamerica-white.png'),
    sulamericabr: require('static/img/insurace-logos/sulamerica-white.png'),
    thinksegbr: require('static/img/insurace-logos/thinkseg-white.png'),
    tokiobr: require('static/img/insurace-logos/tokiomarine-white.png'),
    tokio: require('static/img/insurace-logos/tokiomarine-white.png'),
    youse_br: require('static/img/insurace-logos/youse-white.png')
};

export default whiteLogosBR;
